<div [ngClass]="{'account__wrapper': true, 'account__wrapper--desktop': screen.isDesktop, 'account__wrapper--mobile': screen.isMobile}">
	<ng-content></ng-content>
</div>
